<template>
  <div class="row mainContent">
    <div class="col-xs-9 col-sm-3 col-md-2">
      <WorksIntro :project="project" />
      <transition name="fadeUp" appear>
        <p class="description">{{ project.Description }}</p>
      </transition>
    </div>
    <div class="col-xs-9 col-sm-6 col-md-7">
      <Fade appear :delay="2200">
        <slot></slot>
      </Fade>
    </div>
  </div>
</template>

<script>
import WorksIntro from "@/components/WorksIntro.vue";
import Fade from "@/transitions/Fade.vue";

export default {
  name: "Works",
  components: {
    WorksIntro,
    Fade
  },
  computed: {
    project() {
      return this.$store.state.activeProject;
    },
    captions() {
      return this.$store.getters.captions;
    }
  },
  mounted() {
    this.$store.state.firstLoad = false;
  }
};
</script>

<style lang="scss" scoped>
.mainContent {
  padding-top: 6rem;
}
.description {
  text-align: justify;
  padding-top: 3rem;
  white-space: pre-line;
  transition: opacity 600ms ease-out 2850ms, transform 600ms ease-out 2850ms;
  padding-bottom: $gutter + 1.5rem;
}
.fadeUp-enter {
  opacity: 0;
  transform: translateY(1rem);
}

.fadeUp-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
